export const FETCH_COIN_SETTING = 'FETCH_COIN_SETTING';
export const FETCH_COIN_SETTING_FAILED = 'FETCH_COIN_SETTING_FAILED';
export const FETCH_COIN_SETTING_SUCCEED = 'FETCH_COIN_SETTING_SUCCEED';

export const FETCH_MARKET = 'FETCH_MARKET';
export const FETCH_MARKET_FAILED = 'FETCH_MARKET_FAILED';
export const FETCH_MARKET_SUCCEED = 'FETCH_MARKET_SUCCEED';

export const FETCH_ALL_COIN = 'FETCH_ALL_COIN';
export const FETCH_ALL_COIN_FAILED = 'FETCH_ALL_COIN_FAILED';
export const FETCH_ALL_COIN_SUCCEED = 'FETCH_ALL_COIN_SUCCEED';

export const FETCH_TOMO_COIN = 'FETCH_TOMO_COIN';
export const FETCH_TOMO_COIN_FAILED = 'FETCH_TOMO_COIN_FAILED';
export const FETCH_TOMO_COIN_SUCCEED = 'FETCH_TOMO_COIN_SUCCEED';

export const FETCH_LIMIT_WITHDRAWAL = 'FETCH_LIMIT_WITHDRAWAL';
export const FETCH_LIMIT_WITHDRAWAL_SUCCEED = 'FETCH_LIMIT_WITHDRAWAL_SUCCEED';
export const FETCH_LIMIT_WITHDRAWAL_FAILED = 'FETCH_LIMIT_WITHDRAWAL_FAILED';

export const FETCH_CRYPTO_LIMIT_WITHDRAWAL = 'FETCH_CRYPTO_LIMIT_WITHDRAWAL';
export const FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED = 'FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED';
export const FETCH_CRYPTO_LIMIT_WITHDRAWAL_FAILED = 'FETCH_CRYPTO_LIMIT_WITHDRAWAL_FAILED';

export const FETCH_CRYPTO_SETTING = 'FETCH_CRYPTO_SETTING';
export const FETCH_CRYPTO_SETTING_SUCCEED = 'FETCH_CRYPTO_SETTING_SUCCEED';
export const FETCH_CRYPTO_SETTING_FAILED = 'FETCH_CRYPTO_SETTING_FAILED';

export const FETCH_HASH_SETTING = 'FETCH_HASH_SETTING';
export const FETCH_HASH_SETTING_SUCCEED = 'FETCH_HASH_SETTING';
export const FETCH_HASH_SETTING_FAILED = 'FETCH_HASH_SETTING';

export const POST_COIN_SETTING = 'POST_COIN_SETTING';
export const POST_COIN_SETTING_SUCCEED = 'POST_COIN_SETTING_SUCCEED';
export const POST_COIN_SETTING_FAILED = 'POST_COIN_SETTING_FAILED';

export const FETCH_INFO_ERC20 = 'FETCH_INFO_ERC20';
export const FETCH_INFO_ERC20_FAILED = 'FETCH_INFO_ERC20_FAILED';
export const FETCH_INFO_ERC20_SUCCESS = 'FETCH_INFO_ERC20_SUCCESS';

export const FETCH_TOMO_INFO_ERC20 = 'FETCH__TOMO_INFO_ERC20';
export const FETCH_TOMO_INFO_ERC20_FAILED = 'FETCH_TOMO_INFO_ERC20_FAILED';
export const FETCH_TOMO_INFO_ERC20_SUCCESS = 'FETCH_TOMO_INFO_ERC20_SUCCESS';

export const CREATE_MARKET = 'CREATE_MARKET';
export const CREATE_MARKET_FAILED = 'CREATE_MARKET_FAILED';
export const CREATE_MARKET_SUCCESS = 'CREATE_MARKET_SUCCESS';

export const CLOSE_MARKET = 'CLOSE_MARKET';
export const CLOSE_MARKET_SUCCESS = 'CLOSE_MARKET_SUCCESS';
export const CLOSE_MARKET_FAILED = 'CLOSE_MARKET_FAILED';

export const OPEN_MARKET = 'OPEN_MARKET';
export const OPEN_MARKET_SUCCESS = 'OPEN_MARKET_SUCCESS';
export const OPEN_MARKET_FAILED = 'OPEN_MARKET_FAILED';

export const SELECT_COIN = 'SELECT_COIN';
export const SEARCH_COIN = 'SEARCH_COIN';

export const UPDATE_COIN = 'UPDATE_COIN';
export const UPDATE_COIN_SUCCESS = 'UPDATE_COIN_SUCCESS';
export const UPDATE_COIN_FAILED = 'UPDATE_COIN_FAILED';

export const UPDATE_LIMIT_WITHDRAWAL = 'UPDATE_LIMIT_WITHDRAWAL';
export const UPDATE_LIMIT_WITHDRAWAL_SUCCESS = 'UPDATE_LIMIT_WITHDRAWAL_SUCCESS';
export const UPDATE_LIMIT_WITHDRAWAL_FAILED = 'UPDATE_LIMIT_WITHDRAWAL_FAILED';

export const OPEN_COIN = 'OPEN_COIN';
export const OPEN_COIN_SUCCESS = 'OPEN_COIN_SUCCESS';
export const OPEN_COIN_FAILED = 'OPEN_COIN_FAILED';

export const CLOSE_COIN = 'CLOSE_COIN';
export const CLOSE_COIN_SUCCESS = 'CLOSE_COIN_SUCCESS';
export const CLOSE_COIN_FAILED = 'CLOSE_COIN_FAILED';

export const ADD_CUSTOM_ACTION = 'ADD_CUSTOM_ACTION';
export const ADD_CUSTOM_ACTION_FAILED = 'ADD_CUSTOM_ACTION_FAILED';
export const ADD_CUSTOM_ACTION_SUCCEED = 'ADD_CUSTOM_ACTION_SUCCEED';

export const FETCH_CRYPTO_EXCHANGE_CONFIG = 'FETCH_CRYPTO_EXCHANGE_CONFIG';
export const FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED = 'FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED';
export const FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED = 'FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED';

export const UPDATE_CRYPTO_EXCHANGE_CONFIG = 'UPDATE_CRYPTO_EXCHANGE_CONFIG';
export const UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED = 'UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED';
export const UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED = 'UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED';

export const FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO = 'FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO';
export const FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED = 'FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED';
export const FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED = 'FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED';

export const DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO = 'DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO';
export const DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED = 'DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED';
export const DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED = 'DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED';

export const ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO = 'ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO';
export const ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED = 'ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED';
export const ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED = 'ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED';
